import React, { ReactElement, useState } from 'react';
import { NodeDefaultTeaser } from "@/components/nodeTypes";
import { Carousel, CarouselApi, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import Link from "next/link";
import SliderIndicator from '../ui/slider-indicator';

const Slideshow = ({ nodes }): ReactElement => {
  const [api, setApi] = React.useState<CarouselApi>()
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  React.useEffect(() => {
    if (!api) {
      return
    }

    api.on("select", () => {
      if (!api) return;
      setIsStart(!api.canScrollPrev())
      setIsEnd(!api.canScrollNext())
    })
  }, [api])

  return (
    <Carousel
      setApi={setApi}
      className=''
      opts={{
        align: "start",
        dragFree: true,
      }}
    >
      <div className="w-full overflow-hidden">
        {!isStart &&
          <div className="h-full absolute flex items-center z-10 left-16 2xl:left-52 bottom-5 scale-125 max-md:hidden">
            <CarouselPrevious />
          </div>
        }
        {!isEnd &&
          <div className="h-full absolute flex items-center z-10 right-32 bottom-5 scale-125 max-md:hidden">
            <CarouselNext />
          </div>
        }
        <div className="p-slider-1 z-0">
          <CarouselContent overflowHidden={false}>
            <CarouselItem className="md:basis-[5%] lg:basis-[2%] mx-0 scale-125 max-md:basis-[0%] max-md:invisible">
              {isStart &&
                <CarouselPrevious />
              }
            </CarouselItem>
            {
              nodes.map((content, i) => (
                <CarouselItem key={'slidenode-' + content.id} className="basis-4/5 md:basis-2/5 lg:basis-[30%] mx-3">
                  <NodeDefaultTeaser node={content} showType />
                </CarouselItem>
              ))
            }
            <CarouselItem className="basis-4-5/5 md:basis-2/5 lg:basis-[30%]">
              <div className="rounded-xl text-white bg-podcast-illustration bg-primary p-[18px] transition-all relative flex flex-col justify-end h-full overflow-hidden">
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <Link href="/articles" className="stretched-link relative z-10">
                  <h3 className="text-[32px]">
                    Découvrir d&apos;autres articles
                  </h3>
                </Link>
              </div>
            </CarouselItem>
            <CarouselItem className="md:basis-[5%] lg:basis-[2%] mx-0 scale-125 max-md:basis-[0%] max-md:invisible">
              {isEnd &&
                <CarouselNext />
              }
            </CarouselItem>
          </CarouselContent>
          <SliderIndicator isStart={isStart} isEnd={isEnd} />
        </div>
      </div>

    </Carousel>
  );
};

export default Slideshow;